import { call, put, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  addDataVPOFailure,
  addDataVPOSuccess,
  setLastAddedId,
  updateDataVPOSuccess,
  updateDataVPOFailure,
  deleteDataVPOSuccess,
  deleteDataVPOFailure,
  setLastDocId,
  fetchActionByContextSuccess,
  fetchActionByContextFailure,
  fetchInconsistenciesByActionIdSuccess,
  fetchInconsistenciesByActionIdFailure
} from "./actions";
import { fetchData } from "../filtersData/actions";
import { addData, extractStrapiData, updateData, deleteData, fetchDataByContext, fetchInconsistenciesByActionId } from "../../api/api"
import { delay } from 'redux-saga/effects';
import { AddRequestAction, UpdateRequestAction, DeleteRequestAction, FetchActionByContextRequestAction, FetchInconsistenciesByActionRequestAction } from '../../types/strapiVPO';



export function* addDataVPOSaga(action: AddRequestAction) {
  const { modelName, data, creatorId } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(addData, modelName, data);
    const extractedData = extractStrapiData(response);
    yield put(addDataVPOSuccess(modelName, extractedData, creatorId));
    yield put(setLastAddedId(modelName, extractedData.id));
    if (extractedData.documentId) {
      yield put(setLastDocId(modelName, extractedData.documentId));
    }
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(addDataVPOFailure(modelName, errorMessage));
  }
}

export function* addDataSuccessVPOSaga(action: AddRequestAction) {
  const { modelName } = action.payload;
  yield put(fetchData(modelName));
}

export function* updateDataVPOSaga(action: UpdateRequestAction) {
  const { modelName, documentId, data } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(updateData, modelName, documentId, data);
    const extractedData = extractStrapiData(response);
    yield put(updateDataVPOSuccess(modelName, extractedData));
    if (modelName === 'vpo-inconsistencies' && extractedData.IdVPOactions) {
      yield new Promise(resolve => setTimeout(resolve, 100));
      const inconsistencies: any[] = yield call(fetchInconsistenciesByActionId, extractedData.IdVPOactions);
      yield put(fetchInconsistenciesByActionIdSuccess(inconsistencies));
    }
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(updateDataVPOFailure(modelName, errorMessage));
  }
}

export function* deleteDataVPOSaga(action: DeleteRequestAction) {
  const { modelName, documentId } = action.payload;
  try {
    yield call(deleteData, modelName, documentId);
    yield put(deleteDataVPOSuccess(modelName, documentId));
    if (modelName === 'vpo-inconsistencies') {
      const state: any = yield select();
      const inconsistencies = state.vpoStrapi.formAddActions['vpo-inconsistencies']?.data || [];
      if (inconsistencies.length > 0 && inconsistencies[0].IdVPOactions) {
        const actionId = inconsistencies[0].IdVPOactions;
        yield new Promise(resolve => setTimeout(resolve, 100));
        const updatedInconsistencies: any[] = yield call(fetchInconsistenciesByActionId, actionId);
        yield put(fetchInconsistenciesByActionIdSuccess(updatedInconsistencies));
      }
    }
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(deleteDataVPOFailure(modelName, errorMessage));
  }
}

export function* fetchActionByContextSaga(action: FetchActionByContextRequestAction) {
  try {
    const { modelName, context } = action.payload;
    const vpoActions: any[] = yield call(fetchDataByContext, modelName, context);

    if (vpoActions && vpoActions.length > 0) {
      const enrichedActions = vpoActions.map((vpoAction) => ({
        linkedVpoAction: vpoAction,
        isLinked: true,
        fromStrapi: true,
        context: context,
      }));

      yield put(fetchActionByContextSuccess(enrichedActions));
    } else {
      yield put(fetchActionByContextSuccess([]));
    }
  } catch (error) {
    const errorMessage = (error as any)?.message || 'Ошибка при загрузке действий';
    yield put(fetchActionByContextFailure(errorMessage));
  }
}

export function* fetchInconsistenciesByActionIdSaga(action: FetchInconsistenciesByActionRequestAction) {
  try {
    const { actionId } = action.payload;
    const inconsistencies: any[] = yield call(fetchInconsistenciesByActionId, actionId);
    yield put(fetchInconsistenciesByActionIdSuccess(inconsistencies));
  } catch (error) {
    const errorMessage = (error as any)?.message || 'Ошибка при загрузке несоответствий';
    yield put(fetchInconsistenciesByActionIdFailure(errorMessage));
  }
}